import React from 'react';

import SkillsLandingPage from '../../js/pages/SkillsLandingPage';
import {getTag, getTags} from '../../../server/services/tags';
import {getPublicCoachingData} from '../../../server/services/coaching';
import {getSkill, getCourseCard} from '../../../server/services/cms';
import {SkillCourseMap, RoleCourseMap, IndustryCourseMap} from '../../../lib/constants/coaching';
import {cleanCoaches} from '../../js/util';

export default function Page(props) {
  return <SkillsLandingPage {...props} />;
}

// Serves skill, role, and industry tags. Tag ids are globally unique across
// types (skills that collide with another type use a -skill suffix)
export async function getStaticProps({params}) {
  const tag = await getTag(params.skill);

  if (!tag || !['skill', 'role', 'industry'].includes(tag.type)) {
    return {notFound: true};
  }

  const [skill, coachesData, tagsData, course] = await Promise.all([
    getSkill(params.skill), // Contentful FAQ content; typically null for roles
    getPublicCoachingData(),
    getTags(),
    getCourseCard(
      SkillCourseMap[params.skill]
      || RoleCourseMap[params.skill]
      || IndustryCourseMap[params.skill],
    ),
  ]);

  const {coaches} = coachesData;
  const {allTags: tagMap, products} = tagsData;

  const cleanedCoaches = cleanCoaches(coaches);

  return {
    props: {
      coaches: cleanedCoaches,
      tag,
      skill,
      tagMap,
      course,
      coachingTags: products.coaching,
    },
    revalidate: 3600,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
